var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Realisation"},[(_vm.record)?_c('router-view',{key:_vm.$route.path}):_c('div',{staticClass:"spinner-full-window d-flex"},[_c('b-spinner',{staticClass:"spinner",attrs:{"variant":"secondary"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }